import React, { useMemo } from 'react';
import currency from 'currency.js';
import PreviewImage from '../../PreviewImage';
import styles from './Confirm.module.scss';

export default function OrderPackageItem({ orderPackage, skipImage = false }) {
  const [foreground, background, actualForeground] = useMemo(() => {
    const foreground = orderPackage.sheets.length && orderPackage.sheets[0].pose.watermarkUrl;
    const background = orderPackage.sheets.length && orderPackage.sheets[0].background?.imageUrl || '';
    const actualForeground = orderPackage.sheets.length && orderPackage.sheets[0].foreground?.watermarkUrl;

    return [foreground, background, actualForeground];
  });

  const subtotal = `Cart Subtotal: ${currency(orderPackage.cart.subtotal).format()}`;

  return (
    <div className={styles.orderPackageItem}>
      {!skipImage && (
        <div className={styles.previewImage}>
          <PreviewImage actualForegroundUrl={actualForeground} foregroundUrl={foreground} backgroundUrl={background} />
        </div>
      )}
      <div className={styles.info}>
        <div>
          <p className={styles.packageName}>{`${orderPackage.apiOption.name} Package`}</p>
          <p className={styles.price}>{currency(orderPackage.apiOption.prices[0].price).format()}</p>
        </div>
        <p className={styles.subtotal}>{subtotal}</p>
      </div>
    </div>
  );
}
